export default __webpack_public_path__ + "static/media/cx_cover_c60s.35c0ac90.jpg";